import { AxiosError } from 'axios';

import { createAsyncThunk } from '@reduxjs/toolkit';

import { reportsApi } from '@/api/index';
import type { RIMReportBody, RIMReportParams } from '@/api/routes/reports/types';

export const generateReport = createAsyncThunk(
  'generateReport',
  async ({
    type, params,
  }: {
      type: string, params: RIMReportParams
  }, thunkAPI) => {
    try {
      const response = await reportsApi.generateReport<RIMReportParams, RIMReportBody>(type, params);
      return response ? {
        type,
        params,
        ...response.data
      } : [];
    } catch (e) {
      if (e instanceof AxiosError) {
        return thunkAPI.rejectWithValue(e.message);
      }
      throw e;
    }
  },
);
